// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__SIVa-"};